import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class TransformationDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"TRANSFORMATION"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "TRANSFORMATION",
            transformer: event.detail?.transformer,
            transformSucced: event.detail?.transformSucced ?? true,
          };
    }

    get transformer() {
        return this.detail.transformer;
    }
    set transformer(value) {
        this.detail.transformer = value;
    }

    get transformSucced() {
        return this.detail.transformSucced;
    }

    set transformSucced(value) {
        this.detail.transformSucced = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "transformer", "transformSucced"].includes(key)){
            let commentaire = "Transformation"

            const transformerPlayer = getPlayer(this.transformer, match)
            const team = getTeam(this.team, match)

            if(this.transformer){
                if(transformerPlayer){
                    commentaire += ' de '+ transformerPlayer.lastname
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "! "

            if(!this.transformSucced)
                 commentaire += "Malheureusement la transformation est manquée."

            this.text = commentaire
        }
    }
}